import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "text-grey" }
const _hoisted_4 = { class: "ml-4" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "text-grey" }
const _hoisted_7 = { class: "ml-4" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "text-grey" }
const _hoisted_10 = { class: "ml-4" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "ml-4" }
const _hoisted_13 = {
  key: 1,
  style: {"font-size":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.defecations.length > 0 || _ctx.temperatures.length > 0 || _ctx.milks.length > 0 || _ctx.sleeps.length > 0 )
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.temperatures, (temperature, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "d-flex align-center mb-2",
              key: `${index}-temperature`,
              onClick: ($event: any) => (_ctx.changeTemperature(temperature))
            }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.formatTime(temperature.recordedAt)), 1),
              _createVNode(_component_v_chip, {
                color: "temperature",
                class: "ml-4",
                variant: "outlined",
                size: "x-small"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("体温", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_4, _toDisplayString(temperature.temperature.toFixed(1)) + "℃", 1)
            ], 8, _hoisted_2))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defecations, (defecation, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "d-flex align-center mb-2",
              key: `${index}-defecation`,
              onClick: ($event: any) => (_ctx.changeDefecation(defecation))
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.formatTime(defecation.recordedAt)), 1),
              _createVNode(_component_v_chip, {
                color: "defecation",
                class: "ml-4",
                variant: "outlined",
                size: "x-small"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("排便", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.showDefecationStatus(defecation.state)), 1)
            ], 8, _hoisted_5))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.milks, (milk, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "d-flex align-center mb-2",
              key: `${index}-milk`,
              onClick: ($event: any) => (_ctx.changeMilk(milk))
            }, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.formatTime(milk.recordedAt)), 1),
              _createVNode(_component_v_chip, {
                color: "milk",
                class: "ml-4",
                variant: "outlined",
                size: "x-small"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.categoryToText(milk.milkCategory)), 1)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_10, _toDisplayString(milk.amount? milk.amount.value + 'cc': '不明'), 1)
            ], 8, _hoisted_8))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sleeps, (sleep, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "d-flex align-center mb-2",
              key: `${index}-sleep`,
              onClick: ($event: any) => (_ctx.changeSleep(sleep))
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-grey" }, "ー：ー", -1)),
              _createVNode(_component_v_chip, {
                color: "sleep",
                class: "ml-4",
                variant: "outlined",
                size: "x-small"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("睡眠", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.formatTime(sleep.from)) + " 〜 " + _toDisplayString(_ctx.formatTime(sleep.to)), 1)
            ], 8, _hoisted_11))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, " 記録がありません "))
  ]))
}